import { render } from "./ffswiper.vue?vue&type=template&id=89cff28c"
import script from "./ffswiper.vue?vue&type=script&lang=js"
export * from "./ffswiper.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\FFSTAR3\\VUESP\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__